import type { IconSvgObject } from './types';

const BlenderIcon: IconSvgObject = [
  ["path", { d: "M8.00018 4H18.0002M8.00018 4L9.00018 17M8.00018 4H4.00018L5.00018 9L8.50018 11M18.0002 4L17.0002 17M18.0002 4H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 2H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 22L9 17H17L19 22H7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17.6453 8H15.5M17 11H15.5M17 14H15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BlenderIcon;
